import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconQuestion = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.6 14.954a5.287 5.287 0 0 1 .332-2.059 5.328 5.328 0 0 1 1.31-1.684c.447-.39.864-.821 1.239-1.297.259-.374.403-.82.403-1.281a1.922 1.922 0 0 0-.46-1.382 1.783 1.783 0 0 0-1.369-.476 1.99 1.99 0 0 0-1.397.476c-.36.33-.547.792-.532 1.267H7.678a3.447 3.447 0 0 1 1.21-2.722 4.774 4.774 0 0 1 3.153-.993 4.623 4.623 0 0 1 3.153.993 3.443 3.443 0 0 1 1.124 2.75 4.488 4.488 0 0 1-1.527 3.11l-1.238 1.167a3.14 3.14 0 0 0-.677 2.117h-2.29l.015.014Zm-.172 3.01c0-.345.115-.691.374-.921a1.426 1.426 0 0 1 1.008-.36 1.42 1.42 0 0 1 1.008.36 1.287 1.287 0 0 1 .015 1.8 1.34 1.34 0 0 1-1.023.36 1.34 1.34 0 0 1-1.022-.36c-.23-.23-.36-.562-.36-.893v.014Z"
    />
  </svg>
);
const Memo = memo(SvgIconQuestion);
export default Memo;
